import React from 'react';
import { Brain, ShieldAlert, Zap } from 'lucide-react';
export function ReframeSection() {
  return <section className="py-4 px-4 md:px-12 lg:px-24 bg-[#0a0c0e] border-t border-card-border" data-id="element-345">
      <div className="max-w-4xl mx-auto text-center" data-id="element-346">
        <div className="inline-flex items-center justify-center p-3 bg-alert-red/10 rounded-full mb-6" data-id="element-347">
          <ShieldAlert className="w-8 h-8 text-alert-red" data-id="element-348" />
        </div>

        <h2 className="font-bebas text-4xl md:text-6xl text-white mb-8" data-id="element-349">
          No fallaste tú.{' '}
          <span className="text-alert-red" data-id="element-350">Tu método estaba roto.</span>
        </h2>

        <p className="font-inter text-lg md:text-xl text-text-muted mb-16 max-w-3xl mx-auto leading-relaxed" data-id="element-351">
          La industria habla de 'sanar raíces' o 'fuerza de voluntad'. Nosotros
          hablamos de <strong className="text-white" data-id="element-352">Biología Hardcore</strong>.
          Ese hábito nocturno hackea tu sistema de dopamina. Intentar dejarlo
          con 'ganas' es como poner. cinta adhesiva sobre la luz de 'Falla de
          Motor'. El motor se sigue quemando por dentro.
        </p>
        <p className="text-white font-semibold text-xl text-left border-l-4 border-alert-red pl-4 py-1" data-id="element-353">
          ❌ EL PROBLEMA DE LOS MÉTODOS TRADICIONALES:
        </p>
        <br data-id="element-354" />
        <p className="text-text-muted font-inter text-left" data-id="element-355">
          <strong className="text-white font-bold" data-id="element-356">•</strong> Tratan el problema
          como "falta de carácter" cuando es una LESIÓN NEUROLÓGICA - Los
          pecados requieren perdón, las lesiones requieren sanación
        </p>
        <br data-id="element-357" />
        <p className="text-text-muted font-inter  text-left" data-id="element-358">
          <strong className="text-white font-bold" data-id="element-359"> •</strong> Refuerzan el
          mismo ciclo de recaída - La fuerza de voluntad ACTUALMENTE fortalece
          el bucle neurológico
        </p>
        <br data-id="element-360" />
        <p className="text-text-muted font-inter  text-left" data-id="element-361">
          <strong className="text-white font-bold" data-id="element-362">•</strong> Te atrapan en la
          espiral de vergüenza - Un desliz y "fallaste de nuevo", llevándote al
          aislamiento
        </p>
        <br data-id="element-363" />
        <p className="text-white font-semibold text-xl text-left border-l-4 border-alert-red pl-4 py-1" data-id="element-364">
          ✅ ASÍ ES COMO EL PROTOCOLO DE BLINDAJE LO RESUELVE:
        </p>
        <br data-id="element-365" />
        <p className="text-text-muted font-inter text-left" data-id="element-366">
          Identifica la "Raíz del Secuestro" - Trazamos el origen neurológico
          que genera tus impulsos - - antes de que intentes controlar el
          comportamiento.
        </p>
        <br data-id="element-367" />
        <p className="text-text-muted font-inter  text-left" data-id="element-368">
          Sana la Fuente - No gestionamos síntomas. Aplicamos sanación directa a
          la raíz para que pierda su poder.
        </p>
        <br data-id="element-369" />
        <p className="text-text-muted font-inter  text-left" data-id="element-370">
          Reconstruye tu Identidad - Recuperas la coherencia entre quien eres de
          día y de noche - para que la libertad sea tu estado natural.
        </p>
        <br data-id="element-371" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto" data-id="element-372">
          {/* Hardware Dañado */}

          {/* Sistema Blindado */}
        </div>
      </div>
    </section>;
}